import { useState, useEffect } from 'react';
import RoleService, { Role } from '../services/role';
import { message } from 'antd';

export interface RoleOption {
  value: string;
  label: string;
  color: string;
}

// 预定义角色颜色映射
const ROLE_COLORS: Record<string, string> = {
  'admin': 'red',
  'manager': 'orange',
  'user': 'blue',
  'sales': 'green',
  'editor': 'purple',
  'viewer': 'cyan',
};

export const useRoles = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [roleOptions, setRoleOptions] = useState<RoleOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await RoleService.getRoles();
      if (response.success && response.data) {
        setRoles(response.data);
        
        // 转换为选项格式
        const options: RoleOption[] = response.data.map(role => ({
          value: role.name,
          label: role.display_name || role.name,
          color: ROLE_COLORS[role.name.toLowerCase()] || 'default'
        }));
        
        setRoleOptions(options);
      }
    } catch (error) {
      console.error('获取角色列表失败:', error);
      message.error('获取角色列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return {
    roles,
    roleOptions,
    loading,
    refreshRoles: fetchRoles
  };
};

export default useRoles;
